import React from 'react';

//Estilos base:
let mainCardStyle = {
    paddingTop: 20
};

export const usersManagementTourConfig = [
    {
        selector: '',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Esta es la consola de <b>administración de usuarios</b>.</p>
                <p>Aquí podrás <b>asignar permisos</b> a los usuarios de la plataforma, así como <b>crear nuevos</b> e
                incluso, administrar <b>tu perfil</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.ownProfileManager"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Aquí encontrarás información de <b>tu perfil</b> como cuál es tu rol, qué puedes hacer y tu correo electrónico.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.ownProfileManagerOptions"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Haciendo click aquí, podrás ver las opciones de <b>customización de tu perfil</b>, como cambiar tu contraseña.</p>
            </div>
        )
    },
    {
        adminRequired: true,
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.usersManagement"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Si eres administrador o staff, podrás utilizar este módulo para <b>manipular</b> los permisos de los usuarios.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.rolesInfoCard"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Aquí siempre tendrás a la mano la <b>descripción</b> de cada perfil.</p>
            </div>
        )
    },
    {
        adminRequired: true,
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.usersRoleAsignationButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Si eres administrador o staff, podrás <b>asignar o eliminar</b> permisos a cualquier usuario.</p>
                <p>Para ello, haz click en uno de estos botones. Si está
                    <span style={{ color: "rgb(136,205,156)" }}><b> verde</b></span>, el usuario tiene dicho permiso, si está
                    <span style={{ color: "rgb(222,134,96)" }}><b> rojo</b></span>, entonces no.</p>
                <p>Esta acción generará un registro de <b>auditoría</b>.</p>
            </div>
        )
    },
    {
        adminRequired: true,
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.creteUserButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Si eres administrador o staff, podrás <b>crear</b> nuevos usuarios, haciendo click en este botón.</p>
                <p>El formulario es sencillo: deberás escribir un correo y su clave.</p>
            </div>
        )
    },
    {
        adminRequired: true,
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__usersManagement.deleteUserButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Si eres administrador o staff, podrás <b>eliminar</b> usuarios, haciendo click en este botón.</p>
                <p>Ten presente que esta acción <b>no tiene vuelta atrás</b>.</p>
            </div>
        )
    },
];